const siteId = process.env.REACT_APP_BUILD_SITE;

const ratingsHelpLink = {
  '24MX': 'https://help.inmuebles24.com/s/article/C%C3%B3mo-veo-mi-reputaci%C3%B3n-en-el-portal-i24',
  CAPA: 'http://help.compreoalquile.com/es/articles/8542525-reputacion',
  DVPE: 'https://help.adondevivir.com/es/articles/7047154-20-estadisticas-reputacion',
  IWBR: 'https://help.imovelweb.com.br/pt-BR/articles/8451890-34-como-posso-ver-minha-reputacao-no-portal',
  PLEC: 'https://help.plusvalia.com/s/article/C%C3%B3mo-veo-mi-reputaci%C3%B3n-en-el-portal-PL',
  UBPE: 'https://help.urbania.pe/es/articles/7049072-21-estadisticas-reputacion',
  WIBR: 'https://help.imovelweb.com.br/pt-BR/articles/8451890-34-como-posso-ver-minha-reputacao-no-portal',
  ZPAR: 'https://help.zonaprop.com.ar/s/article/C%C3%B3mo-veo-mi-reputaci%C3%B3n-en-el-portal',
  CMBR:
    'https://intercom.help/casa-mineira-internet-ltda/pt-BR/articles/8681372-29-como-posso-ver-minha-reputacao-no-portal'
};

export const redirectToHelp = ratingsHelpLink[siteId];
